export default __webpack_public_path__ + "static/media/KomikaTitle.2564b065.ttf";